import { Fragment } from 'react';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { rage } from '~/rage';
import {
	StyledBgShadow1,
	StyledBgShadow2,
	StyledBgShadow3,
	StyledBgShadowContainer,
} from './Background.styled';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.VehicleShop} />
		)}
		<StyledBgShadowContainer>
			<StyledBgShadow1 />
			<StyledBgShadow2 />
			<StyledBgShadow3 />
		</StyledBgShadowContainer>
	</Fragment>
);

export { Background };
